import * as _ from 'lodash';
import { combineReducers, Reducer } from 'redux';
import { IFacets, IFacetResult } from '../state-helpers/facets';
import {
    IAction,
    ActionType,
    IUpdateSearchFacet,
    ISetMobileFacetsVisibility,
    ISetSelectedFacetCount,
    ISetFacetDropdownVisibility,
    setMobileFacetsVisibility,
    setSelectedFacetCount,
    setFacetDropdownVisibility
} from '../actions/index';

export const facetsModel: Reducer<IFacets> = combineReducers({
    facets: updateFacetsModel,
    mobileFacetsVisible: mobileFacetsVisibilityModel,
    dropdownVisible: facetDropdownVisibilityModel,
    selectedFacetCount: updatedSelectedFacetCount
});


export function updateFacetsModel(state: IFacetResult[], action: IUpdateSearchFacet) {
    if (typeof state === 'undefined') {
        state = [] as IFacetResult[];
    }

    switch (action.type) {
        case ActionType.UPDATE_FACETS:
            return action.facets;
        default:
            return state;
    }
}

export function mobileFacetsVisibilityModel(state: boolean, action: ISetMobileFacetsVisibility) {
    if (typeof state === 'undefined') {
        state = false;
        return state;
    }

    switch (action.type) {
        case ActionType.SET_MOBILE_FACETS_VISIBILITY:
            return setMobileFacetsVisibility(action.visible).visible;
        default:
            return state;
    }
}

export function updatedSelectedFacetCount(state: number, action: ISetSelectedFacetCount) {

    if (typeof state === 'undefined') {
        state = 0;
    }

    switch (action.type) {
        case ActionType.SET_SELECTED_FACET_COUNT:
            return setSelectedFacetCount(action.selectedFacetCount).selectedFacetCount;
        default:
            return state;
    }
}

export function facetDropdownVisibilityModel(state: boolean, action: ISetFacetDropdownVisibility) {
    if (typeof state === 'undefined') {
        state = false;
        return state;
    }

    switch (action.type) {
        case ActionType.SET_FACET_DROPDOWN_VISIBILITY:
            return setFacetDropdownVisibility(action.visible).visible;
        default:
            return state;
    }
}
